import React from 'react';
import { connect } from 'react-redux';
import AcceptInvitationForm from './AcceptInvitationForm';
import api from '../../../utils/api';
import queryString from 'query-string';
import { Col, Row } from 'react-flexbox-grid';
import LinearProgress from 'material-ui/LinearProgress';

class AcceptInvitationView extends React.Component {
    onSubmit = values => {
        const qs = queryString.parse(this.props.location.search);

        values = values.toJS();
        values.invitation_token = qs.invitation_token;
        values.endpointPrefix = qs.tenant_name;
        this.props.accept_invitation(values);
    };

    render = () => {
        let style = {
            opacity: 1,
        };
        if (this.props.isFetching === true) {
            style = {
                opacity: 0.25,
                pointerEvents: 'none',
            };
        }

        return (
            <div style={{padding:20}}>
                <h1>Passwort festlegen</h1>
                {this.props.isFetching && (
                    <Row>
                        <Col md={12} sm={12} xs={12}>
                            <LinearProgress
                                mode="indeterminate"
                                color="#3babd0"
                                style={{
                                    left: '0px',
                                    height: '10px',
                                    top: '63px',
                                    right: '0px',
                                    position: 'absolute',
                                }}
                            />
                        </Col>
                    </Row>
                )}
                <div style={style}>
                    <AcceptInvitationForm onSubmit={this.onSubmit} />
                </div>
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    isFetching: state.registration.get('isFetching'),
});

const mapDispatchToProps = dispatch => ({
    accept_invitation: payload => dispatch(api.actions.registration.accept_invitation(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AcceptInvitationView);
